import {useSelector} from 'react-redux';

import {UserTariffCountKey} from './IUser';
import {userSelector} from './authSlice';

const useIsTariffFeatureUnavailable = (field: UserTariffCountKey): boolean => {
    const user = useSelector(userSelector);

    return user?.tariff?.[field] === 0;
};

export default useIsTariffFeatureUnavailable;
